import {message} from "antd";
import  AgencyMaintainService from "../../agency_maintain/service";

export const SYS_MGT_ORG_DEPT_LIST = "SYS_MGT_ORG_DEPT_LIST"; // 部门组织列表
export const SYS_MGT_DEPT_EXPAND_ORG = "SYS_MGT_DEPT_EXPAND_ORG"; // 展开父组织
export const SYS_MGT_TOGGLE_LOADING_DATA = "SYS_MGT_LOADING_DATA "; // 是否正在加载数据
export const SYS_MGT_DEPT_TOGGLE_DISABLE_ORG = "SYS_MGT_DEPT_TOGGLE_DISABLE_ORG"; //启用或禁用组织
export const SYS_MGT_DEPT_DELETE_ORG = "SYS_MGT_DEPT_DELETE_ORG"; //删除部门
export const SYS_MGT_DEPT_ADD_ORG = "SYS_MGT_DEPT_ADD_ORG"; //新增部门
export const SYS_MGT_DEPT_EDIT_ORG = "SYS_MGT_DEPT_EDIT_ORG";  // 编辑部门
export const SYS_MGT_DEPT_TREE_LOAD = "SYS_MGT_DEPT_TREE_LOAD"; // 加载树的子节点
export const SYS_MGT_DEPT_SELECTED_KEY = "SYS_MGT_DEPT_SELECTED_KEY"; // 设置选中的keys
export const SYS_MGT_DEPT_EXPANDED_KEYS = "SYS_MGT_DEPT_EXPANDED_KEYS"; // 设置展开的行号
export const SYS_MGT_DEPT_TREE_SELECT = "SYS_MGT_DEPT_TREE_SELECT"; // 组织单位树形选择
export const SYS_MGT_DEPT_UPDATE_LOGO = "SYS_MGT_DEPT_UPDATE_LOGO"; // 更新单位logo;

/**
 * 启用或禁用组织
 */
export const toggleDisableOrg = (orgNo, status) => {
    return dispatch => {
        const msg = status == true ? "启用成功" : "停用成功";
        message.success(msg, 1);
       return dispatch({
            type: SYS_MGT_DEPT_TOGGLE_DISABLE_ORG,
            orgNo: orgNo,
            status: status})
    }
}

/**
 * 删除组织
 */
export const deleteOrg = (orgNo, type) => {
    return dispatch => {
        return AgencyMaintainService.sysMgtDeptService.orgDeptDelete(orgNo, type).then(json => {
            if(json.code == 0){
                message.success("删除成功");
                return dispatch({
                    type: SYS_MGT_DEPT_DELETE_ORG,
                    orgNo: orgNo,
                    orgType: type
                })
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("删除组织异常:" + e);
            message.error("删除失败");
        })
    }
}

/**
 * 添加组织
 */
export const addOrg = (org, parentOrgNo) => {
    return {
        type: SYS_MGT_DEPT_ADD_ORG,
        org: org,
        parentOrgNo: parentOrgNo
    }
}

/**
 * 编辑组织
 */
export const editOrg = (org) => {
    return {
        type: SYS_MGT_DEPT_EDIT_ORG,
        org: org
    }
}


/**
 * 部门单位列表
 * @param parentOrgNo 父级id
 * @param type 父级类型  0:单位  1:部门
 */
export const orgDeptList = (parentOrgNo, type) => {
    return dispatch => {
        dispatch({
            type: SYS_MGT_TOGGLE_LOADING_DATA,
            isLoading: true
        })
        return AgencyMaintainService.sysMgtDeptService.orgDeptList(parentOrgNo, type).then(json => {
            if(json.code == 0){
                if(parentOrgNo == null){
                    dispatch({
                        type: SYS_MGT_ORG_DEPT_LIST,
                        orgList: json.data
                    })
                    if(json.data.length > 0){
                        dispatch(setSelectedOrg({
                            key: json.data[0].id,
                            isDept: json.data[0].type == 1,
                            orgNo: json.data[0].orgNo,
                            orgName: json.data[0].orgName,
                            deptNo: json.data[0].deptNo,
                            deptName: json.data[0].deptName
                        }));
                        dispatch(setExpandedKeys([json.data[0].id]))
                        orgDeptList(json.data[0].id, json.data[0].type.type);
                    }
                }else{
                    dispatch({
                        type: SYS_MGT_DEPT_EXPAND_ORG,
                        orgList: json.data,
                        parentOrgNo: parentOrgNo
                    })
                }
            }else{
                message.error("获取部门列表失败");
            }
        }).catch(e => {
            console.error("获取部门列表异常:" + e)
            message.error("获取部门列表失败");
        }).then(() => dispatch({
            type: SYS_MGT_TOGGLE_LOADING_DATA,
            isLoading: false
        }));
    }
}

/**
 * 加载部门树
 * @param parentOrgNo 父组织单位编号
 * @param type 父组织类型 0:单位 1:部门
 * @param isLoad 是否为加载子节点
 * @returns {Function}
 */
export const loadTreeNode = (treeNode, resolve) => {
    return dispatch => {
        AgencyMaintainService.sysMgtDeptService.orgDeptList(treeNode.id, treeNode.type).then(json => {
            if(json.code == 0) {
                treeNode.dataRef.children = json.data
                dispatch({
                    type: SYS_MGT_DEPT_TREE_LOAD
                })
                resolve();
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("获取组织单位异常:" + e);
            message.error("获取单位失败");
        })
    };
}

/**
 * 设置选中的key
 * @param keys 选中的key id
 */
export const setSelectedOrg = (selectedOrg) => {
    return {
        type: SYS_MGT_DEPT_SELECTED_KEY,
        selectedOrg: selectedOrg
    }
}

/**
 *  设置展开的行
 * @param keys 展开的行号
 */
export const setExpandedKeys = (keys) => {
    return {
        type: SYS_MGT_DEPT_EXPANDED_KEYS,
        keys: keys
    }
}

/**
 * 获取组织树列表
 * @param parentOrgNo 父id
 * @param type 类型
 */
export const getOrgTreeList = (parentOrgNo, type) => {
    return dispatch => {
        return new Promise(resolve =>  AgencyMaintainService.sysMgtDeptService.orgDeptList(parentOrgNo, type).then(json => {
           if(json.code == 0){
               dispatch({
                   type: SYS_MGT_DEPT_TREE_SELECT,
                   data: json.data,
                   parentOrgNo: parentOrgNo
               })
               resolve();
           }else{
               message.error(json.msg);
           }
        }).catch(e => {
            console.error("获取单位异常:" + e);
            message.error("获取单位失败");
        }))
    }
}
// 更新组织单位url
export const updateLogoUrl = (orgNo, logoUrl) => {
  return {
      type: SYS_MGT_DEPT_UPDATE_LOGO,
      orgNo: orgNo,
      logo: logoUrl
  }
};


